import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

export interface HtmlTemplateDraftBannerProps {
    timestamp: number;
    onRestore(): void;
    onDiscard(): void;
}

export const HtmlTemplateDraftBanner = (props: HtmlTemplateDraftBannerProps) => (
    <div className='bg-status-info/10 text-foreground-default mx-4 mb-3 flex items-center justify-between gap-3 rounded-md px-3 py-2 text-sm'>
        <div className='flex min-w-0 flex-col'>
            <span className='font-medium'>
                <FormattedMessage
                    id='content-detail.editor.draft-recovery-title'
                    description='Title shown when a recoverable local HTML template draft exists'
                    defaultMessage='Unsaved draft available'
                />
            </span>
            <span className='text-brand-muted truncate'>{new Date(props.timestamp).toLocaleString()}</span>
        </div>
        <div className='flex shrink-0 items-center gap-2'>
            <button
                className='text-brand-primary hover:text-brand-secondary text-sm font-medium'
                type='button'
                onClick={props.onRestore}>
                <FormattedMessage
                    id='content-detail.editor.restore-draft'
                    description='Button label for restoring a local HTML template draft'
                    defaultMessage='Restore'
                />
            </button>
            <button
                className='text-status-danger text-sm font-medium'
                type='button'
                onClick={props.onDiscard}>
                {CommonMessage.BUTTONS.DISCARD}
            </button>
        </div>
    </div>
);
